module.exports = __webpack_public_path__ + "img/bac en bois.df2d6982.jpeg";